import { api, ApiCallerMap, CallerType, ApiNames } from "../api/api";
import { getAuthInstance } from "@tailormed/common-client/services/auth";
import { oktaConfig } from "../constant/okta";
import { useFetch } from "./fetch";

function getApiMethod(apiName) {
  if (ApiCallerMap[apiName] === CallerType.Auth) {
    const token = getAuthInstance(oktaConfig.redirectUri).getAccessToken();
    return (...params) => api(apiName)(token, ...params);
  }

  return api(apiName);
}

/**
 * Call an API method, returning the result for use as component-local state
 *
 * Note: For populating data in the store, use Saga hooks instead of this!
 *
 * @param {ApiNames} apiName - An entry from `ApiNames` to call
 * @returns {[invoke: function, result: object, isFetching: boolean, error: string, reset: function] - The state of the request:
 *  * invoke() - A function to invoke the API call
 *  * result - The result of a successful API call
 *  * error - The error message from a failed API call
 *  * isFetching - True if the request is in progress
 *  * reset - A method to reset the state for another invocation
 */
function useApi(apiName) {
  return useFetch(getApiMethod(apiName));
}

export { useApi, ApiNames };
